import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { I18nextProvider } from "react-i18next";

import i18n from "@web/i18n";
import { SessionProvider } from "@web/auth/session";
import "@web/styles.css";

import { router } from "./app/router";

// Entry point of the Verso PLATFORM CONSOLE (ADR-0014 §6 phase 2). Deliberately a smaller shell than
// the product's (apps/web/src/main.tsx): the operator has no mail-language preference to settle
// (`PreferredLanguageSync` writes `PUT /api/profile/language` for the signed-in person's own tenant,
// which the cross-tenant console does not address), so the only providers here are i18n and the
// session. Everything they are made of is apps/web's — this is a second entry over one implementation,
// not a second implementation.

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

createRoot(rootEl).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <Suspense fallback={null}>
        <SessionProvider>
          <RouterProvider router={router} />
        </SessionProvider>
      </Suspense>
    </I18nextProvider>
  </StrictMode>,
);
